var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTokLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 449.22 511.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m449,128c-29.2,0-56.2-9.7-77.8-26-24.8-18.7-42.7-46.2-49-77.8-1.6-7.8-2.4-15.9-2.5-24.2h-83.5v228.1l-.1,124.9c0,33.4-21.8,61.7-51.9,71.7-8.8,2.9-18.2,4.3-28,3.7-12.6-.7-24.3-4.5-34.6-10.6-21.8-13-36.5-36.6-36.9-63.7-.6-42.2,33.5-76.7,75.7-76.7,8.3,0,16.3,1.4,23.8,3.8v-84.6c-7.9-1.2-15.9-1.8-24.1-1.8-46.2,0-89.4,19.2-120.3,53.8C16.5,274.7,2.5,308.1.3,343.1c-2.8,45.9,14,89.6,46.6,121.8,4.8,4.7,9.8,9.1,15.1,13.2,27.9,21.5,62.1,33.2,98.1,33.2,8.1,0,16.2-.6,24.1-1.8,33.6-5,64.6-20.4,89.1-44.6,30.1-29.7,46.7-69.2,46.9-111.2l-.4-186.6c14.3,11.1,30,20.2,46.9,27.3,26.2,11.1,54,16.6,82.5,16.6v-83.1c.1.1-.2.1-.2.1h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokLogo);
export default __webpack_public_path__ + "static/media/tikTokLogo.347e0547570ac6034ffcdcde20dc06c8.svg";
export { ForwardRef as ReactComponent };